export class UserRelation {
         userRelationId?: number;
         userId: string;
         studentId: string;
         relationType:number;
       }